import gql from 'graphql-tag'

export const ADD_BANNER = gql`
mutation(
  $file: FileInput!,
  $url: String,
  $onlineDate: Date!,
  $closeDate: Date!,
  $status: Boolean!
  $WebApp:String
  $BannerTypeId: ID!
  $name: String
  $empId:[ID]
){
  addBanner(info:{
    file: $file,
    url:$url,
    onlineDate:$onlineDate,
    closeDate:$closeDate,
    status: $status,
    WebApp: $WebApp
    BannerTypeId: $BannerTypeId
    name: $name
    empId:$empId
  }
  )
  {
   _id
    image{
      _id
      src
      size
    }
    name
    url
    onlineDate
    closeDate
    status
    WebApp
    BannerTypeId{
      _id
      name
    }
    
  }
  }
`
export const UPDATE_BANNER = gql`
mutation(
  $bannerId: ID!,
    $file: Fileupdate,
  $url: String,
  $onlineDate: Date!,
  $closeDate: Date!,
  $status: Boolean!
  $WebApp:String
  $BannerTypeId: ID!
  $name: String
  $empId:[ID]
){
  updateBanner(info:{
    bannerId:$bannerId,
    file:$file,
    url: $url,
    onlineDate: $onlineDate,
    closeDate:$closeDate,
    status: $status,
    WebApp: $WebApp
    BannerTypeId:$BannerTypeId
    name: $name
    empId:$empId
  })
  {
    _id
    image{
      _id 
      src
      size
    }
    url
    onlineDate
    closeDate
    name
    status
    WebApp
    BannerTypeId{_id name}
  }
}
`
export const GET_BANNER = gql`
query(
    $type: String!,
    $page: Int!,
    $perPage: Int!
    $search: String!
  )
  {
  getBanner(type:$type, page:$page, perPage: $perPage, search:$search){
    banners{
       _id
    image{
      _id
      src
      mimeType
      size
    }
    url
    onlineDate
    closeDate
    status
    name
    click
    BannerTypeId{
      _id
      name
    }
    }
     totals
   
  }
  }
`
export const DELETE_BANNER = gql`
mutation(
    $bannerId:ID!
  ){
    deleteBanner(
      bannerId:$bannerId
    )
  }
`
export const GET_BANNER_BYID = gql`
query(
  $id: ID!
){
  findBanner(
    id:$id
  ){
      _id
  image{
    _id
    src
    mimeType
    size
  }
  url
  name
  onlineDate
  closeDate
  status
  click
    WebApp
  BannerTypeId{
    _id
    name
  }
  empId{
    _id 
    name
  }
  }
  }
`